/**
 * Application-wide constants
 */

/**
 * UI Breakpoints
 */
export const MOBILE_BREAKPOINT = 768; // md breakpoint in Tailwind (pixels)

/**
 * Search Configuration
 */
export const MAX_RECENT_SEARCHES = 5;

/**
 * Timeout Values (in milliseconds)
 */
// Uploads can be large (up to 100MB) and some networks are slow.
// Keep this generous to avoid flaky client-side timeouts.
export const FILE_UPLOAD_TIMEOUT = 20 * 60 * 1000; // 20 minutes
export const QUOTE_ROTATION_INTERVAL = 5 * 60 * 1000; // 5 minutes
